/* pantallas-alumno (B): LA TARJETA DE MODO DEL CENTRO DE ESTUDIO (piezas nuevas de la parte 1).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Boton de opcion unica: fondo #141414, borde #222222, radio 18 (medidas de hoy: abajo, centro-espacio).
   Antes: relleno 18, alto minimo 150 en computadora, 160 en tablet y 112 en el celular. Icono de 44 (36 en el celular) en cuadro #1C130D;
   circulo de seleccion de 22 arriba a la derecha (borde 1.5 #3A3A3A; elegida: borde y punto de 11
   naranja); nombre 16 seminegrita; descripcion 13/18 #9A9A9A con dos renglones reservados.
   Elegida: borde #F27A2E de 2 px y fondo #17100B. El segundo px del borde es una sombra interior: la
   caja no cambia de medida al elegirla (regla 4). Apagada: 45 %.
   Celular: icono y nombre centrados, el chip debajo del nombre, sin descripcion ni circulo.
   En computadora el chip va junto al nombre; en tablet, debajo (como el PDF).

   `FilaDeModos` es la fila de tres: una rejilla que estira las tres al mismo alto.

   centro-espacio (orden de Carlos del 20-oct): LA TARJETA, MUCHO MAS BAJA, y sin `compacta` (los escalones se
   fueron). Celular: como mucho 64 de alto (icono de 24 arriba, el nombre de 13 debajo; si el nombre parte en dos, las
   tres crecen igual por la fila). Desde 768: como mucho 96 (icono de 24, 28 desde 1024, en el renglon del nombre, el circulo a la
   derecha de ese renglon y la descripcion debajo en uno o dos renglones, con "..." si no cabe). El chip va
   montado sobre el borde de arriba (no suma alto); en el celular, centrado. El toque sigue en 44 o mas. */
import React from 'react';
import { APRETADO } from './botones';

const CAJA = 'relative w-full h-full text-left flex flex-col max-md:items-center max-md:justify-center max-md:text-center rounded-[18px] border focus:outline-none focus-visible:ring-2 focus-visible:ring-white';
const TAMANO = 'min-h-[52px] px-1.5 py-1.5 md:p-3';
const NORMAL = 'bg-[#141414] border-[#222222] hoverable:border-[#3A3A3A]';
const ELEGIDA = 'bg-[#17100B] border-[#F27A2E] shadow-[inset_0_0_0_1px_#F27A2E]';

export default function TarjetaDeModo({
  icono: Icono, nombre, descripcion, chip, elegida = false, apagada = false, onElegir, alTocarApagada, testid, className = '',
}) {
  const alTocar = () => {
    if (apagada) { if (alTocarApagada) alTocarApagada(); return; }
    if (onElegir) onElegir();
  };
  return (
    <button
      type="button"
      role="radio"
      aria-checked={elegida}
      aria-disabled={apagada || undefined}
      onClick={alTocar}
      data-testid={testid}
      data-elegida={elegida ? 'true' : undefined}
      className={`${CAJA} ${TAMANO} ${elegida ? ELEGIDA : NORMAL}${apagada ? ' opacity-45 cursor-not-allowed' : ` ${APRETADO}`}${className ? ` ${className}` : ''}`}
    >
      {chip ? <span data-parte="chip" className="absolute -top-[11px] left-1/2 -translate-x-1/2 md:left-3 md:translate-x-0 leading-none">{chip}</span> : null}
      <span data-parte="circulo" aria-hidden="true"
        className={`max-md:hidden absolute top-[15px] right-3 w-[22px] h-[22px] rounded-full border-[1.5px] flex items-center justify-center ${elegida ? 'border-[#F27A2E]' : 'border-[#3A3A3A]'}`}>
        {elegida ? <span data-parte="punto" className="w-[11px] h-[11px] rounded-full bg-[#F27A2E]" /> : null}
      </span>
      {/* El renglon del nombre: en el celular, el icono arriba y el nombre abajo; desde 768, lado a lado y con lugar
          para el circulo. El nombre parte dentro de la tarjeta, nunca se sale. */}
      <span className="flex flex-col md:flex-row md:items-center gap-1 md:gap-1.5 min-w-0 max-w-full max-md:items-center md:pr-6">
        <span data-parte="icono" aria-hidden="true" className="w-6 h-6 lg:w-7 lg:h-7 shrink-0 rounded-lg bg-[#1C130D] flex items-center justify-center">
          {Icono ? <Icono className="w-4 h-4 text-[#F27A2E]" /> : null}
        </span>
        <span data-parte="nombre" className="min-w-0 text-[13px] md:text-[16px] leading-tight font-semibold text-[#F4F4F3] break-words max-w-full">{nombre}</span>
      </span>
      {descripcion ? (
        <span data-parte="descripcion" className="max-md:hidden mt-1 text-[13px] leading-[18px] text-[#9A9A9A] line-clamp-2">{descripcion}</span>
      ) : null}
    </button>
  );
}

export function FilaDeModos({ etiqueta, children, testid, className = '' }) {
  return (
    <div role="radiogroup" aria-label={etiqueta} data-testid={testid}
      className={`grid grid-cols-3 gap-2 md:gap-4 items-stretch ${className}`.trim()}>
      {children}
    </div>
  );
}
